import React, { Component } from 'react';
import { connect } from 'react-redux';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('TRANSACTION_INVOICE_WARNINGS_AND_DELETE_LOG', LOG_LEVELS.DEBUG);

class WarningsAndDeleteLog extends Component {

  render() {
    log.debug('render(): ', this.props);

    const warnings = this.props.warnings;
    const deleteLog = this.props.deleteLog;

    return(
      <div>
        <br />
        {warnings.length > 0 ? (
          <div>
            <h2 class="mt30"><LanguageStringResolver string="transactionInvoice_warnings_title"/></h2>
            <ul className="warning-message ml20">
              {warnings.map((item,index) => (
                <li key={index} >
                  {item.errorMessage}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div></div>
        )}
        {deleteLog.length > 0 ? (
          <div>
            <h2 class="mt30"><LanguageStringResolver string="transactionInvoice_delete_log_title"/></h2>
            <ul className="warning-message ml20">
              {deleteLog.map((item,index) => (
                <li key={index} >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(WarningsAndDeleteLog);
